/*
  Claude 4.04 — Recently viewed strip (product pages only).

  Design notes, so a later session does not "fix" these on sight:

  - Storage is localStorage ONLY. Nothing is sent anywhere. The snapshot is
    written server-side-accurate by the Liquid section on each product view
    (title, price string, image, group key), so the strip paints instantly with
    zero network requests.
  - Availability is then revalidated against /products/{handle}.js. This is
    deliberately NOT the /search?q=id:... section-render trick: this store
    creates one-off hides constantly and the search index lags, so a just-viewed
    hide can be missing from its own history. The .js endpoint never lags.
  - Grouping collapses colour siblings (combined listings are ~581 separate
    single-variant products here). Group key = product title with its trailing
    ", Colour" segment removed, computed in Liquid.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-crv]');
  if (!root) return;

  var KEY = 'crv:v1';

  var cfg = {
    heading: root.getAttribute('data-heading') || 'Recently viewed',
    max: parseInt(root.getAttribute('data-max'), 10) || 6,
    min: parseInt(root.getAttribute('data-min'), 10) || 2,
    store: parseInt(root.getAttribute('data-store'), 10) || 12,
    ttl: (parseInt(root.getAttribute('data-ttl'), 10) || 30) * 86400000,
    dedupe: root.getAttribute('data-dedupe') === 'true',
    revalidate: root.getAttribute('data-revalidate') === 'true',
    showSold: root.getAttribute('data-show-sold') === 'true',
    money: root.getAttribute('data-money-format') || '\u00a3{{amount}}'
  };

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      var cut = Date.now() - cfg.ttl;
      return list.filter(function (e) {
        return e && e.handle && typeof e.ts === 'number' && e.ts > cut;
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode / quota — the strip simply does not persist */
    }
  }

  var current = null;
  var currentEl = document.getElementById('ClaudeRecentlyViewedCurrent');
  if (currentEl) {
    try { current = JSON.parse(currentEl.textContent); } catch (e) { current = null; }
  }

  if (current && current.handle) {
    var kept = read().filter(function (e) { return e.id !== current.id; });
    current.ts = Date.now();
    kept.unshift(current);
    write(kept.slice(0, cfg.store));
  }

  function pick() {
    var out = [];
    var seenId = {};
    var seenGroup = {};
    var curId = current ? current.id : null;
    var curGroup = current ? current.group : null;

    read().forEach(function (e) {
      if (e.id === curId) return;
      if (seenId[e.id]) return;
      if (cfg.dedupe && e.group) {
        if (curGroup && e.group === curGroup) return;
        if (seenGroup[e.group]) return;
        seenGroup[e.group] = 1;
      }
      seenId[e.id] = 1;
      out.push(e);
    });

    return out.slice(0, cfg.max);
  }

  function thousands(intStr) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fmt(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var amt = cents / 100;
    var fixed = amt.toFixed(2);
    var intPart = fixed.split('.')[0];
    var decPart = fixed.split('.')[1];
    var rounded = String(Math.round(amt));

    var out = cfg.money
      .replace(/\{\{\s*amount\s*\}\}/g, thousands(intPart) + '.' + decPart)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, thousands(rounded))
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/g,
        thousands(intPart).replace(/,/g, '.') + ',' + decPart
      )
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        thousands(rounded).replace(/,/g, '.')
      );

    /* money_format can carry markup, and this shop's format appends a trailing
       space (see the 3.83 "£399 ·" finding) — strip both. */
    return out.replace(/<[^>]*>/g, '').trim();
  }

  var items = pick();
  if (items.length < cfg.min) return;

  var byHandle = {};

  function card(e) {
    var li = document.createElement('li');
    li.className = 'crv__item';

    var a = document.createElement('a');
    a.className = 'crv__link';
    a.href = e.url || '/products/' + e.handle;

    var media = document.createElement('div');
    media.className = 'crv__media';
    if (e.image) {
      var img = document.createElement('img');
      img.src = e.image;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 160;
      img.height = 160;
      media.appendChild(img);
    }

    var name = document.createElement('p');
    name.className = 'crv__name';
    name.textContent = e.title || '';

    var price = document.createElement('p');
    price.className = 'crv__price';
    price.textContent = e.price || '';

    a.appendChild(media);
    a.appendChild(name);
    a.appendChild(price);
    a.setAttribute('aria-label', (e.title || '') + (e.price ? ', ' + e.price : ''));

    li.appendChild(a);
    byHandle[e.handle] = li;
    return li;
  }

  var head = document.createElement('div');
  head.className = 'crv__head';

  var h2 = document.createElement('h2');
  h2.className = 'crv__title';
  h2.textContent = cfg.heading;

  var clear = document.createElement('button');
  clear.type = 'button';
  clear.className = 'crv__clear';
  clear.textContent = 'Clear';
  clear.addEventListener('click', function () {
    try { window.localStorage.removeItem(KEY); } catch (e) {}
    root.hidden = true;
    while (root.firstChild) root.removeChild(root.firstChild);
  });

  head.appendChild(h2);
  head.appendChild(clear);

  var track = document.createElement('ul');
  track.className = 'crv__track';
  items.forEach(function (e) { track.appendChild(card(e)); });

  root.appendChild(head);
  root.appendChild(track);
  root.hidden = false;

  function removeCard(handle) {
    var li = byHandle[handle];
    if (li && li.parentNode) li.parentNode.removeChild(li);
    delete byHandle[handle];
    write(read().filter(function (e) { return e.handle !== handle; }));
    if (track.children.length < cfg.min) {
      root.hidden = true;
    }
  }

  function patchStored(handle, patch) {
    var list = read().map(function (e) {
      if (e.handle !== handle) return e;
      var copy = {};
      Object.keys(e).forEach(function (k) { copy[k] = e[k]; });
      Object.keys(patch).forEach(function (k) { copy[k] = patch[k]; });
      return copy;
    });
    write(list);
  }

  function apply(handle, p) {
    var li = byHandle[handle];
    if (!li) return;

    var nameEl = li.querySelector('.crv__name');
    var priceEl = li.querySelector('.crv__price');
    var link = li.querySelector('.crv__link');

    if (nameEl && p.title) nameEl.textContent = p.title;

    if (p.available === false) {
      if (!cfg.showSold) {
        removeCard(handle);
        return;
      }
      li.classList.add('crv__item--sold');
      var media = li.querySelector('.crv__media');
      if (media && !media.querySelector('.crv__badge')) {
        var badge = document.createElement('span');
        badge.className = 'crv__badge';
        badge.textContent = 'Sold';
        media.appendChild(badge);
      }
      if (priceEl) priceEl.textContent = 'See similar';
      if (link) {
        link.setAttribute('aria-label', (p.title || '') + ', sold — see similar');
      }
      patchStored(handle, { available: false, title: p.title || '' });
      return;
    }

    var priceStr = fmt(p.price);
    if (priceEl && priceStr) priceEl.textContent = priceStr;
    if (link) {
      link.setAttribute('aria-label', (p.title || '') + (priceStr ? ', ' + priceStr : ''));
    }
    patchStored(handle, {
      available: true,
      title: p.title || '',
      price: priceStr || ''
    });
  }

  if (!cfg.revalidate || typeof window.fetch !== 'function') return;

  items.forEach(function (e) {
    window
      .fetch('/products/' + encodeURIComponent(e.handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      .then(function (r) {
        if (r.status === 404 || r.status === 410) {
          removeCard(e.handle);
          return null;
        }
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (p) {
        if (p) apply(e.handle, p);
      })
      .catch(function () {
        /* offline or blocked — the snapshot card stays, which is the point */
      });
  });
})();
